module.exports = __webpack_public_path__ + "static/img/video.4cd228e8.png";